// Lab gallery — replace these stock images with real Noosaville facility photos when available.
// Each image should be 1200×800 or larger, JPG/WebP optimised.
//
// URL params: Pexels honours `?auto=compress&cs=tinysrgb&w=<n>` to return a
// pre-compressed, downscaled responsive variant. Without `cs=tinysrgb` the
// CDN still serves the full-resolution master (~1.4 MB each). Keep:
//   • feature tiles (lg:col-span-2)  → w=1200
//   • secondary tiles                → w=800
//
// Hard limit ~150 KB per tile keeps total gallery payload < 1 MB.
export const LAB_GALLERY = [
  {
    src: "https://images.pexels.com/photos/3735709/pexels-photo-3735709.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Scientist analysing water sample with pipette in laboratory",
    caption: "Sample preparation",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    src: "https://images.pexels.com/photos/2280571/pexels-photo-2280571.jpeg?auto=compress&cs=tinysrgb&w=800",
    alt: "Glass beakers with clear water on laboratory bench",
    caption: "Clean reagents",
    span: "",
  },
  {
    src: "https://images.pexels.com/photos/3735780/pexels-photo-3735780.jpeg?auto=compress&cs=tinysrgb&w=800",
    alt: "Test tubes with water samples being analysed",
    caption: "Bacterial analysis",
    span: "",
  },
  {
    src: "https://images.pexels.com/photos/2280549/pexels-photo-2280549.jpeg?auto=compress&cs=tinysrgb&w=1200",
    alt: "Lab technician reviewing water quality test results",
    caption: "Result review",
    span: "lg:col-span-2",
  },
  {
    src: "https://images.pexels.com/photos/3735762/pexels-photo-3735762.jpeg?auto=compress&cs=tinysrgb&w=800",
    alt: "Bench-top pH and conductivity testing equipment",
    caption: "Calibrated instruments",
    span: "",
  },
  {
    src: "https://images.pexels.com/photos/416528/pexels-photo-416528.jpeg?auto=compress&cs=tinysrgb&w=800",
    alt: "Clear filtered water being poured into a glass",
    caption: "Clear, reliable results",
    span: "",
  },
];

// Public-facing team profiles.
// ⚠️ PLACEHOLDER CONTENT — replace with real names, photos and credentials before launch.
// If the lab prefers not to publish individual team members, set TEAM = [] and the section
// will gracefully render an alternate "team capability" block instead.
export const TEAM = [
  {
    name: "Lab Director",
    role: "Operations & Quality",
    bio: "Oversees laboratory operations, documented procedures and quality control across every batch tested.",
    photo: null,
    initials: "LD",
  },
  {
    name: "Senior Chemist",
    role: "Water Quality Analysis",
    bio: "Leads chemical and bacteriological analysis — drinking water, rainwater tanks and bore water profiling.",
    photo: null,
    initials: "SC",
  },
  {
    name: "Laboratory Technician",
    role: "Sample Handling & Testing",
    bio: "Sample receipt, preparation and routine testing using documented procedures and calibrated instruments.",
    photo: null,
    initials: "LT",
  },
  {
    name: "Customer Care",
    role: "Reports & Recommendations",
    bio: "Translates lab results into plain-English summaries and coordinates next-step guidance with our specialist partners.",
    photo: null,
    initials: "CC",
  },
];

export const TEAM_CAPABILITIES = [
  "Trained in recognised laboratory methodologies",
  "Experienced across rainwater tank and bore water analysis",
  "Documented procedures and quality-control workflows",
  "Direct access to water-treatment specialists through Pristine Water Systems Sunshine Coast",
];
